(function () {
  if (window.__mgTimeline) return;
  window.__mgTimeline = true;

  function select(panel) {
    panel.parentElement.querySelectorAll('.mg-tl__panel').forEach(function (p) {
      p.setAttribute('aria-expanded', p === panel ? 'true' : 'false');
    });
  }

  function panelFrom(e) {
    return e.target.closest ? e.target.closest('.mg-tl__panel') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var panel = panelFrom(e);
    if (panel && panel.getAttribute('aria-expanded') !== 'true') select(panel);
  });

  document.addEventListener('click', function (e) {
    var panel = panelFrom(e);
    if (panel) select(panel);
  });

  document.addEventListener('focusin', function (e) {
    var panel = panelFrom(e);
    if (panel && panel.getAttribute('aria-expanded') !== 'true') select(panel);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var panel = panelFrom(e);
    if (panel) {
      e.preventDefault();
      select(panel);
    }
  });
})();
